import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useMakeLlmPublic = () => {
  const {
    data: isMade,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const makeLlmPublic = async (llmName: string) => {
    await call(`/admin/llm/${llmName}/public`, "PUT");
  };

  return {
    makeLlmPublic,
    isMade,
    isLoading,
    isFailed,
  };
};
